import service from './axios';

// 获取支付方式列表
export const fetchPaymentMethodList = (params) => {
  return service({
    method: 'get',
    url: '/manage/payment-methods',
    params
  });
};

// 获取支付方式详情
export const fetchPaymentMethodDetail = (id) => {
  return service({
    method: 'get',
    url: `/manage/payment-methods/${id}`,
  });
};

// 新增支付方式
export const addPaymentMethod = (data) => {
  return service({
    method: 'post',
    url: '/manage/payment-methods',
    data
  });
};

// 更新支付方式
export const updatePaymentMethod = (id, data) => {
  return service({
    method: 'put',
    url: `/manage/payment-methods/${id}`,
    data
  });
};

// 删除支付方式
export const deletePaymentMethod = (id) => {
  return service({
    method: 'delete',
    url: `/manage/payment-methods/${id}`,
  });
};

// 前端获取支付方式列表
export const getFrontendPaymentMethods = () => {
  return service({
    method: 'get',
    url: '/front/payment-methods'
  });
};
